var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.step === 0
        ? _c("enter-address", {
            on: {
              next: _vm.next,
              close: function($event) {
                _vm.$emit("close")
              }
            }
          })
        : _vm.step === 1
          ? _c("select-district", { on: { next: _vm.next, prev: _vm.prev } })
          : _vm.step === 2
            ? _c("pin-confirmation", { on: { next: _vm.next, prev: _vm.prev } })
            : _vm.step === 3
              ? _c("data-confirmation", {
                  on: { next: _vm.next, prev: _vm.prev }
                })
              : _c("set-name-and-create", {
                  on: {
                    prev: _vm.prev,
                    created: function($event) {
                      _vm.created($event)
                    }
                  }
                })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd006c02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd006c02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Addresses/NewAddress/Index.vue
// module id = null
// module chunks = 